import { JudgementData } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface GetInspectionTypeParam {
  rmaNo: string;
  categoryId: string;
  typeId: string;
}

export interface GetJudgementParam {
  rmaNo: string;
}

const endPoint = 'inspection/judgements';

export const fetchJudgementData = async (
  params: GetJudgementParam,
): Promise<JudgementData> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
